<template>
  <div class="container" style="padding-top: 65px">
    <!-- 面包屑导航 -->
    <Nav :navbar="navbar"></Nav>
    <div class="flex flex-x-between flex-y-start list-wrap">
      <div class="title">
        <span>快速导航</span>
      </div>
      <!-- 快速导航 -->

      <div class="notice">
    <ul>
      <li  class="flex">
        <span class="flex-box" @click="navHandle(item.strId)">全会日程</span>
      </li>
    </ul>
  </div>
      <!-- 列表 -->
      <div class="leader flex-box">
        <ul v-if="list.length > 0">
          <li
            class="flex flex-x-between flex-y-center"
            v-for="(item, index) in list"
            :key="index"
            @click="detailHandle(item)"
          >
            <span >{{ item.strContentTxt }}</span>
            <i>{{ item.strMasTitle }}</i>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
       
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/base/nav.vue";
// import { listData } from "@/api/configuration";
// import { get } from "../../utils/helpers";
import { homeData, bodyData } from "@/api/configuration";
export default {
  name: "List",
  components: {
    Nav,

  },
  props: {},
  data() {
    return {
      navbar: [], // 面包屑导航
      list: [], // 列表
     
    };
  },
  watch: {
    $route(to, from) {
    //   this.getListData(1, true);
    },
  },
  created() {
    // this.getListData(1, true);
    this.getInfoData()
  },
  methods: {
       //获取首页数据
    getInfoData() {
      const that = this;
      homeData({
        strWebSiteId:
          // this.$store.state.strWebSiteId || "9c6dfadce15643dd802277534a3f6b47", // 十二届九次
          // this.$store.state.strWebSiteId || "a19f7663d33c44d7a5d0b1f6bda26d68", // 十二届五次
          this.$store.state.strWebSiteId || "b4ac4453111f42ea89394a33ea137dbf", // 十三届一次
      })
        .then((res) => {
          let firstData = res.data.data;
          document.title = firstData.strName;
          const data = firstData.webPositionData;
          data.forEach(async (v, k) => {
            console.log(v)
            if(v.strColName=='会议日程'){
            // let curObj = data[k];
            await bodyData({
              strColId: v.strColId,
              strColName: v.strColName,
              intCount: v.intCount,
            })
              .then((res) => {
                this.list= res.data.data.infoData
                // const secData = res.data.data;
                // that.$set(that.webPositionData, k, secData);
                // if (k === 5 && secData.infoData && secData.infoData.length) {
                //   that.photoWidth = 290 * Number(secData.infoData.length) * 2;
                //   that.move();
                // }
                // console.log(that.webPositionData)
                // if (this.webPositionData[2]) {
                //   this.meetData[0] = this.webPositionData[2]['infoData'][0]
                //   console.log(JSON.stringify(this.meetData) + '=========00---------------')
                // }
              })
              .catch((err) => {
                that.$message.destroy();
                that.$message.error(err);
              });
            }

          });
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },
 




    // 跳转详情
    detailHandle(i) {
   
        this.$router.push({
          path: "/detail",
          query: {
            strId: i.strId,
            strWebSiteId: this.$route.query.strWebSiteId,
          },
        });

    },
  },
};
</script>

<style scoped lang="less">

.notice {
  width: 225px;
  min-height: 500px;
  // }
  ul {
    box-sizing: border-box;
    padding: 10px 10px 5px;
    margin: 0;
    li {
      box-sizing: border-box;
      margin-top: 10px;
      font-size: 14px;
      color: #fff;
      width: 160px;
      height: 40px;
      line-height: 40px;
      background: url("../../assets/images/nav-bg.png") no-repeat center center;
      background-size: 100% 100%;
      text-align: center;
      cursor: pointer;
      span {
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
      }
      i {
        font-style: normal;
        color: #999;
        font-family: "SimSun";
      }
    }
  }
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.list-wrap {
  // margin: 8px auto;
  .title {
    width: 100%;
    margin: 10px auto;
    margin-left: 20px;
    position: relative;
    box-sizing: border-box;
    border-bottom: 3px solid #ccc;
    height: 37px;
    span {
      box-sizing: border-box;
      display: inline-block;
      color: #4a4a4a;
      font-size: 20px;
      font-weight: bold;
      height: 37px;
      line-height: 37px;
      padding: 0 20px 0 0;
      border-bottom: 4px solid #df3036;
    }
  }
}
.leader {
  border: solid 1px #ccc;
  box-sizing: border-box;
  padding: 12px 25px 22px;
  margin: 0 0 0 15px;
  ul {
    margin-bottom: 20px;
    li {
      box-sizing: border-box;
      padding: 0 6px 0 35px;
      font-size: 18px;
      color: #666;
      height: 42px;
      line-height: 55px;
      border-bottom: 1px dashed rgb(161, 161, 161);
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 15px;
        top: 0px;
        width: 7px;
        height: 7px;
        display: inline-block;
        background: #e60a12;
        margin-top: 23px;
        transform: rotate(45deg);
      }
      span {
        display: block;
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        cursor: pointer;
        &:hover {
          color: #df3036;
        }
      }
      i {
        font-style: normal;
        font-size: 16px;
        color: #999;
      }
    }
  }
  .no-content {
    text-align: center;
    box-sizing: border-box;
    padding: 100px 0;
  }
  .page-wrap {
    color: #4a4a4a;
    font-size: 16px;
    span {
      margin: 0 5px;
      i {
        display: inline-block;
        font-style: normal;
      }
    }
    p {
      padding: 0 10px;
      color: #000;
      border: 1px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 3px;
      line-height: 24px;
      font-size: 12px;
      &:hover {
        color: #405fb9;
      }
    }
    > div {
      margin: 0 5px;
      input {
        width: 60px;
        padding: 0 10px;
        color: #000;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        margin: 0 6px;
        height: 26px;
        line-height: 24px;
        font-size: 12px;
        :focus {
          border: 1px solid #dcdada !important;
        }
      }
    }
    b {
      font-weight: normal;
      margin-left: 10px;
      padding: 0 15px;
      color: #000;
      border: 1px solid #ccc;
      border-radius: 5px;
      cursor: pointer;
      margin: 0 3px;
      line-height: 24px;
      font-size: 12px;
      background-color: #efefef;
      &:hover {
        color: #405fb9;
      }
    }
  }
}
</style>
